import { DateSelector } from "@/Common/Components/Inputs/DateSelector";
import { BaseBritishColumbiaObstetricalFileSubSection, BaseBritishColumbiaObstetricalFileSubSectionProps } from "@/Patient/Components/MedicalNote/Obstetric/Form/BritishColumbia/Subcomponent/BaseBritishColumbiaObstetricalFileSubSection";

class BritishColumbiaObstetricalFileTobaccoSubSection extends BaseBritishColumbiaObstetricalFileSubSection<BaseBritishColumbiaObstetricalFileSubSectionProps, never> {
    private datePickerRef: DateSelector;

    public render(): JSX.Element {
        const model = this.props.form.Section9.Tobacco;

        return (
            <tbody className="space-sm-before-tbody">
                <tr>
                    <td className="bold">{this.getString("TobaccoLabel")}</td>
                    <td>
                        {this.renderInlineNoYesRadio(
                            model?.SmokedTobaccoThreeMonthsBeforePregnancy,
                            value => this.props.mutateModelState(s => s.Section9.Tobacco.SmokedTobaccoThreeMonthsBeforePregnancy = value),
                            "Section9_SmokedTobaccoThreeMonthsBeforePregnancy"
                        )}
                    </td>
                    <td>
                        {this.renderInlineNoYesRadio(
                            model?.SmokesTobaccoDuringPregnancy,
                            value => this.props.mutateModelState(s => s.Section9.Tobacco.SmokesTobaccoDuringPregnancy = value),
                            "Section9_SmokesTobaccoDuringPregnancy"
                        )}
                    </td>
                </tr>
                <tr>
                    <td>{this.getString("ObstetricalFile_NumberCigarettesPerDayLabel")}</td>
                    <td>
                        {this.controlRenderer.renderTextbox({
                            value: model?.CigarettesPerDayThreeMonthsBeforePregnancy?.toString() ?? "",
                            onChange: value => this.props.mutateModelState(
                                s => {
                                    s.Section9.Tobacco.CigarettesPerDayThreeMonthsBeforePregnancy = value;
                                    if (!!s.Section9.Tobacco.CigarettesPerDayThreeMonthsBeforePregnancy)
                                        s.Section9.Tobacco.SmokedTobaccoThreeMonthsBeforePregnancy ??= true;
                                }
                            ),
                            maxLength: this.page1FieldLimits.SubstanceUse_3MonthsBeforePregnancy_CigarettesPerDay.MaxChars
                        })}
                    </td>
                    <td>
                        {this.controlRenderer.renderTextbox({
                            value: model?.CigarettesPerDayDuringPregnancy?.toString() ?? "",
                            onChange: value => this.props.mutateModelState(
                                s => {
                                    s.Section9.Tobacco.CigarettesPerDayDuringPregnancy = value;
                                    if (!!s.Section9.Tobacco.CigarettesPerDayDuringPregnancy)
                                        s.Section9.Tobacco.SmokesTobaccoDuringPregnancy ??= true;
                                }
                            ),
                            maxLength: this.page1FieldLimits.SubstanceUse_DuringPregnancy_CigarettesPerDay.MaxChars
                        })}
                    </td>
                </tr>
                <tr>
                    <td>{this.getString("ObstetricalFile_Exposed2HandSmokeLabel")}</td>
                    <td>
                        {this.renderInlineNoYesRadio(
                            model?.WasExposedToSecondHandSmokeThreeMonthsBeforePregnancy,
                            value => this.props.mutateModelState(s => s.Section9.Tobacco.WasExposedToSecondHandSmokeThreeMonthsBeforePregnancy = value),
                            "Section9_WasExposedToSecHandSmokeThreeMonthsBeforePregnancy"
                        )}
                    </td>
                    <td>
                        {this.renderInlineNoYesRadio(
                            model?.IsExposedToSecondHandSmokeDuringPregnancy,
                            value => this.props.mutateModelState(s => s.Section9.Tobacco.IsExposedToSecondHandSmokeDuringPregnancy = value),
                            "Section9_IsExposedToSecHandSmokeDuringPregnancy"
                        )}
                    </td>
                </tr>
                <tr>
                    <td colSpan={3}>
                        <div className="nowrap">
                            <span>{this.getString("QuitTobaccoLabel")}:</span>
                            <span className="margin-sm-left">
                                {this.renderInlineNoYesRadio(
                                    model?.HasQuitTobacco,
                                    value => this.props.mutateModelState(
                                        s => s.Section9.Tobacco.HasQuitTobacco = value,
                                        () => model?.HasQuitTobacco && this.datePickerRef.open()
                                    ),
                                    "Section9_HasQuitTobacco"
                                )}
                            </span>
                            <span className="margin-md-left section9-date-container">
                                {this.renderInlineDatePicker(
                                    "DateLabel",
                                    model?.QuitTobaccoDate,
                                    value => this.props.mutateModelStateWithFormUpdate(
                                        s => {
                                            s.Section9.Tobacco.QuitTobaccoDate = value;
                                            s.Section9.Tobacco.HasQuitTobacco ??= !!value;
                                        }
                                    ),
                                    "",
                                    "normal-text",
                                    ref => this.datePickerRef = ref
                                )}
                            </span>
                        </div>
                    </td>
                </tr>
            </tbody>
        );
    }

    private renderInlineNoYesRadio(value: boolean, onChange: (value: boolean) => void, id: string): JSX.Element {
        return this.controlRenderer.renderInlineYesNoRadio(value, onChange, id, "resizable", null, true);
    }
}

export { BritishColumbiaObstetricalFileTobaccoSubSection };
